import React, { lazy } from 'react';
export function TrustedBySection() {
  const brands = [{
    name: 'Casa Veve',
    logo: 'https://cdn.magicpatterns.com/uploads/gcYyXGUkzU2h4dP2qP13VV/casaveve-new-logo-white_700x.webp'
  }, {
    name: 'The Charming Keepsake Co',
    logo: 'https://cdn.magicpatterns.com/uploads/wYyrRu1WnmXFJ7c7KWaH3K/Picsart_22-09-26_14-40-44-704_-_Edited.webp'
  }, {
    name: 'Twig Story',
    logo: 'https://cdn.magicpatterns.com/uploads/kPXh7YmnsNMiZCdAAqwG5t/twigstorylogo_-_Edited.webp'
  }, {
    name: 'Amruth Ayurveda',
    logo: 'https://cdn.magicpatterns.com/uploads/5bR5SEWcKVJuaRb8Y9THc4/e761b3d5-7d3b-41cc-9a73-87d63f22ab8e.png'
  }, {
    name: 'Fit House',
    logo: 'https://cdn.magicpatterns.com/uploads/akEymYCf8PK9gk78kCsVHR/1716a8e8-686a-42d2-afa3-9aaa47a182df.png'
  }, {
    name: 'Raptor Gym',
    logo: 'https://cdn.magicpatterns.com/uploads/8SYQoaTFEdk335avwiRq97/white_logo_transparent_background.png'
  }, {
    name: '4BK TV',
    logo: 'https://cdn.magicpatterns.com/uploads/r1xHSjAr8HdU895isfYAUz/6f6a7b70-95dc-491e-b838-33587aa73935_(1).png'
  }, {
    name: 'UpCup Koffee',
    logo: 'https://cdn.magicpatterns.com/uploads/tDdQ2Lz5U1htwGbiMeYYMR/upcup_logo_A_Better_Life_in_Every_Cup.webp',
    noFilter: true
  }];
  // Duplicate for seamless infinite scroll
  const marqueeItems = [...brands, ...brands];
  return <section className="py-24 border-y border-white/5 bg-[#020202] overflow-hidden relative" data-id="element-314">
      <div className="max-w-7xl mx-auto px-6 mb-16 text-center relative z-10" data-id="element-315">
        <p className="text-sm font-semibold text-gray-500 tracking-widest uppercase mb-4" data-id="element-316">
          Powering 1,000+ Ecommerce Brands
        </p>
        <h2 className="text-3xl md:text-4xl font-bold text-white max-w-3xl mx-auto tracking-tight" data-id="element-317">
          Trusted by ambitious merchants to scale their Shopify revenue.
        </h2>
      </div>

      {/* Marquee Container */}
      <div className="relative w-full overflow-hidden flex py-10" data-id="element-318">
        {/* Gradient Masks for smooth fade at edges */}
        <div className="absolute left-0 top-0 bottom-0 w-40 bg-gradient-to-r from-[#020202] to-transparent z-10 pointer-events-none" data-id="element-319" />
        <div className="absolute right-0 top-0 bottom-0 w-40 bg-gradient-to-l from-[#020202] to-transparent z-10 pointer-events-none" data-id="element-320" />

        {/* Scrolling Track */}
        <div className="flex whitespace-nowrap animate-marquee items-center" data-id="element-321">
          {marqueeItems.map((brand, i) => <div key={i} className="mx-16 flex items-center justify-center shrink-0 opacity-40 hover:opacity-100 transition-opacity duration-300 cursor-default select-none grayscale hover:grayscale-0" data-id="element-322">
              <img src={brand.logo} alt={brand.name} className={`h-10 md:h-12 w-auto object-contain ${brand.noFilter ? '' : 'brightness-0 invert'}`} loading="lazy" data-id="element-323" />
            </div>)}
        </div>
      </div>
    </section>;
}